import { AxiosResponse } from "axios";

import { BaseProviderException } from "./base-provider.exception";

export class ErrorsProviderException extends BaseProviderException {
  constructor(response: AxiosResponse, message = "Validation Errors") {
    super(response, message);
  }
}
